import { HomeTwoTone } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react'
import { useNavigate } from 'react-router-dom';

function HomeButton() {

    const navigate = useNavigate();

    return (
        <Button onClick={() => navigate("/")}><HomeTwoTone /></Button>
    )

}

export default HomeButton